import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=6629ec4a&scoped=true&lang=pug&"
import script from "./Flow.vue?vue&type=script&lang=js&"
export * from "./Flow.vue?vue&type=script&lang=js&"
import style0 from "./Flow.vue?vue&type=style&index=0&id=6629ec4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6629ec4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6629ec4a', component.options)
    } else {
      api.reload('6629ec4a', component.options)
    }
    module.hot.accept("./Flow.vue?vue&type=template&id=6629ec4a&scoped=true&lang=pug&", function () {
      api.rerender('6629ec4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Flow.vue"
export default component.exports